export default "data:text/javascript;base64,aW1wb3J0IFRGcmVxdWVuY3kgZnJvbSAiLi9URnJlcXVlbmN5LnZ1ZSI7CgpleHBvcnQgZGVmYXVsdCBURnJlcXVlbmN5Owo="